// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multicheck__label{padding-left:0;display:flex;align-items:center;margin-bottom:.25rem}.multicheck__label>input{margin-right:.25rem}", ""]);
// Exports
module.exports = exports;
